import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
let ViedocDrawerListItem = class ViedocDrawerListItem extends LitElement {
    render() {
        return html `<li>
      <slot></slot>
    </li>`;
    }
};
ViedocDrawerListItem.styles = [
    css `
      li {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        font-family: var(--font-family-viedoc);
        font-size: var(--font-size-2xl);
        border-top: 1px solid var(--color-gray-80);
        padding: 1.5rem clamp(1.5rem, 3.33vw, 3rem);
        min-height: 5.5rem;
      }

      li:hover {
        --link-color: var(--color-gray-40);
      }

      li:last-child {
        border-bottom: 1px solid var(--color-gray-80);
      }
    `,
];
ViedocDrawerListItem = __decorate([
    customElement('viedoc-drawer-list-item')
], ViedocDrawerListItem);
export { ViedocDrawerListItem };
